import _ from "lodash";
import API from "../api";
export default {
	namespaced: true,
	state: {
		_list: new Array,
		_total: 0
	},
	mutations: {},
	actions: {
		uploadMerryMamaUser({ state }, data) {
			return new Promise(async (resolve, reject) => {
				try {
					const { userList, message } = (await API.uploadMerryMamaUser(data)).data;
					state._list = userList.list;
					state._total = userList.total;
					resolve({ message });
				} catch (error) {
					reject(error)
				}
			});
		},
		_getMerryMamaUserList({ state }, query) {
			return new Promise(async (resolve, reject) => {
				try {
					const { list, total } = (await API.__getMerryMamaUserList(query)).data;
					state._list = list;
					state._total = total;
					resolve();
				} catch (error) {
					reject(error)
				}
			});
		},
		_deleteMerryMamaUser({ state }, email) {
			return new Promise(async (resolve, reject) => {
				try {
					(await API.__deleteMerryMamaUser(email)).data;
					state._list.splice(state._list.findIndex(user => user.email == email), 1);
					resolve();
				} catch (error) {
					reject(error)
				}
			});
		},
	}
}